
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ScheduledPickup } from '@/features/dashboard/types';
import { useFormatTimestamp } from '@/features/common/helpers';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component
export default class PickupItemDetails extends Vue {
  @Prop({ required: false, default: false }) show!: boolean;

  @Prop({ required: true }) pickup!: ScheduledPickup;

  private useFormatTimestamp = useFormatTimestamp;

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.pickup.carrierCode, this.pickup.selectedService || '');
  }
}
